/* eslint-disable no-unused-vars */
var json_variable = {
	"information": {
		"videourl": [
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2010/video/utilizing-the-qualysguard-api-to-implement-an-effective-vm-program.mp4",
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2010/video/utilizing-the-qualysguard-api-to-implement-an-effective-vm-program.webm",
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2010/video/utilizing-the-qualysguard-api-to-implement-an-effective-vm-program.ogg"
		],
		"slideurl": "https://d1dejaj6dcqv24.cloudfront.net/presentations/utilizing-the-qualysguard-api-to-implement-an-effective-vm-program/",
		"title": "Presentation Title",
		"date": "10-1-2012",
		"time": "8:00 AM",
		"offset": 0
	},
	"presenters": [],
	"slides": [{
		"time": "00:00:00",
		"title": "Introduction",
		"url": "Slide1.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:00:15",
		"title": "Benefits of Implementing QualysGuard API",
		"url": "Slide2.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:01:53",
		"title": "SCAs QualysGuard API",
		"url": "Slide3.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:02:35",
		"title": "Asset Management",
		"url": "Slide4.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:03:41",
		"title": "Asset Management: Search",
		"url": "Slide5.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:03:59",
		"title": "Asset Management: Upload CSV File",
		"url": "Slide6.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:04:22",
		"title": "Asset Management Add Assets",
		"url": "Slide7.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:04:31",
		"title": "Asset Hierarchy",
		"url": "Slide8.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:05:03",
		"title": "Scanning Via API",
		"url": "Slide9.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:05:59",
		"title": "Chapter Title",
		"url": "Slide10.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:07:18",
		"title": "Scan History",
		"url": "Slide11.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:08:23",
		"title": "SCAs Remediation Process",
		"url": "Slide12.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:09:08",
		"title": "Chapter Title",
		"url": "Slide13.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:10:15",
		"title": "Remediation Tracking",
		"url": "Slide14.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:11:07",
		"title": "Vulnerability Search",
		"url": "Slide15.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:12:04",
		"title": "Chapter Title",
		"url": "Slide16.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:12:22",
		"title": "Trend Analysis ",
		"url": "Slide17.jpg",
		"chapter": 1,
		"notes": ""
	}]
};
/* eslint-enable no-unused-vars */
